export const keys = {
  all: ["analytics-filter"] as const,
  getFilter: (orgId: string) => [...keys.all, orgId] as const
};
